<script>
import AppCard from '@/Shared/AppCard.vue';
import AppWell from '@/Shared/AppWell.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';
import { Tippy } from 'vue-tippy';

export default {
    name: 'ContentBlockTagScores',
    components: { AppCard, AppWell, InertiaSquareLinkButton, ProgressBar, Tippy },
    props: {
        contentBlocks: {},
    },
};
</script>
<template>
    <div class="md:grid md:grid-cols-2 md:gap-6">
        <div v-for="block in contentBlocks" :key="block.id">
            <AppWell>
                <AppCard>
                    <div class="p-1">
                        <div class="flex justify-between">
                            <div class="font-bold">
                                {{ block.name }}
                            </div>
                            <div>
                                <InertiaSquareLinkButton
                                    v-if="block.links.show"
                                    :href="block.links.show"
                                    action="show"
                                />
                            </div>
                        </div>
                        <div class="divide-y-2 divide-gray-400">
                            <div class="mt-3" v-for="section in block.sections" :key="section.name">
                                <div>
                                    {{ section.name }}
                                </div>
                                <ul class="pl-3 divide-y divide-gray-300">
                                    <li
                                        class="flex gap-x-2 mt-5 items-center justify-between"
                                        v-for="tag in section.tags"
                                        :key="tag.id"
                                    >
                                        <div class="text-sm">{{ tag.name }}</div>
                                        <div class="mt-1 w-40">
                                            <div v-for="mode in tag.modes" :key="mode.name">
                                                <Tippy>
                                                    <ProgressBar
                                                        :percent="mode.percent"
                                                        :color="mode.color"
                                                        height="sm"
                                                        :show-text="false"
                                                        class="mt-1 w-40"
                                                    />
                                                    <template #content>
                                                        <div class="font-bold">{{ mode.name }}</div>
                                                        <div>{{ $tc('messages.questions', 2) }}: {{ mode.total }}</div>
                                                        <div v-if="mode.total">
                                                            <span>{{ $t('messages.correct_questions') }}:&nbsp;</span>
                                                            <span
                                                                >{{ mode.correct }} / {{ mode.total }} (
                                                                {{ mode.percent }}%)</span
                                                            >
                                                        </div>
                                                    </template>
                                                </Tippy>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </AppCard>
            </AppWell>
        </div>
    </div>
</template>
